import { KeyValueModel } from "model";
import { EnumArquivoRegistro } from "model/enums/enum-arquivo-registro";

export const ArquivoRegistroMock: KeyValueModel[] = [
    new KeyValueModel(EnumArquivoRegistro.Boleto, "Boleto"),
    new KeyValueModel(EnumArquivoRegistro.Remessa, "Remessa"),
    new KeyValueModel(EnumArquivoRegistro.Historico, "Histórico"),
    new KeyValueModel(EnumArquivoRegistro.Transferencias, "Transferências")
];